import React from "react";

const ZonePanelClosed: React.FC = () => {
  return (
    <div className={"zone-panel"}>
      <div
        className="img-closed"
        style={{ backgroundImage: `url(https://panel.eaktywni.pl/img/1215/BILET_SEZONOWY_VOUCHER_PREZENTOWY.jpg)` }}
      ></div>
      <p className={"description-closed-text"}>Szanowni Goście,</p>
      <p className={"description-closed-text"}>Bardzo dziękujemy za wspólny sezon 2024 w Julinek Park.</p>
      <p className={"description-closed-text"}>Nasz Park jest już nieczynny. Do zobaczenia w nowym sezonie!</p>
      <p className={"description-closed-text"} style={{paddingTop: 20}}>Zespół Julinek Park</p>
    </div>
  );
};

export default ZonePanelClosed;
